export default function Maillage() {
  const liens = [
    {
      href: "/sangle-volet-roulant",
      title: "Remplacement de sangle de volet roulant",
      desc: "La sangle est souvent endommagée en même temps que la manivelle. Découvrez notre service de remplacement rapide.",
    },
    {
      href: "/reparation-volet-roulant",
      title: "Réparation complète de volet roulant",
      desc: "Toutes les pannes de volets roulants : manuel, électrique, motorisé, toutes marques à Strasbourg.",
    },
    {
      href: "/cordon-volet-roulant",
      title: "Remplacement de cordon de volet roulant",
      desc: "Si le cordon d'alimentation de votre volet motorisé est endommagé, nous le remplaçons avec les mêmes standards de qualité.",
    },
  ];

  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-8">
          Pages connexes
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {liens.map((lien, i) => (
            <a
              key={i}
              href={lien.href}
              className="group bg-brand-light rounded-xl border border-brand-border p-5 hover:border-brand-cyan transition-colors"
            >
              <h3 className="font-semibold text-brand-blue mb-2 group-hover:text-brand-cyan transition-colors text-sm md:text-base">
                {lien.title}
              </h3>
              <p className="text-sm text-brand-text leading-relaxed">{lien.desc}</p>
              <span className="inline-flex items-center gap-1 text-brand-cyan text-sm font-medium mt-3">
                En savoir plus <i className="ri-arrow-right-line"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}